// QrScanButton.tsx
import { useState, useCallback } from "react";
import Lottie from "lottie-react";
import qrScan from "../../../assets/qr_scan.json";
import QrScannerModalV2 from "./QrScannerModalV2";
import { parseCitizenQR } from "../../../utils/parseCCCD";
import { CitizenQRInfo } from "../../../types/citizenQRInfo";

export default function QrScanButton({
  onDecoded,
}: {
  onDecoded: (info: CitizenQRInfo) => void;
}) {
  const [open, setOpen] = useState(false);
  const qrStyle = { width: 35, height: 35 };

  const handleDecoded = useCallback(
    (txt: string) => {
      var info = parseCitizenQR(txt);
      onDecoded?.(info);
      setOpen(false);
    },
    [onDecoded]
  );

  return (
    <>
      <div
        className="h-full w-[45px] cursor-pointer shrink-0 rounded-xl border-2 border-green-600 flex items-center justify-center"
        onClick={() => {
          setOpen(true);
        }}
        role="button"
        tabIndex={0}
        aria-label="Mở quét QR CCCD"
      >
        <Lottie
          animationData={qrScan}
          loop={true}
          autoplay={true}
          style={qrStyle}
          aria-label={"QrScan"}
        />{" "}
      </div>

      <QrScannerModalV2
        open={open}
        onClose={() => setOpen(false)}
        onDecoded={handleDecoded}
      />
    </>
  );
}
